<template>
	<div>
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" style="width: 60%">
			<el-form-item label="账户余额"  prop="account">
				{{ruleForm.account}}&nbsp;元
			</el-form-item>
			<el-form-item label="提现方式" prop="withdrawalMethod">
				<el-radio-group v-model="ruleForm.withdrawalMethod">
					<el-radio :label="1" name="withdrawalMethod">微信</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="申请提现金额" prop="withdrawalAmount" class="withdrawal">
				<el-input placeholder="请输入提现金额"  v-model="ruleForm.withdrawalAmount" type="number" :min="0.00" :step="0.01"  @keyup.native="ruleForm.withdrawalAmount = checkMoney(ruleForm.withdrawalAmount)">
					<template slot="append">元</template>
				</el-input>
			</el-form-item>
			<el-form-item label="真实姓名" prop="user_name" class="withdrawal">
				<el-input placeholder="请输入真实姓名"  v-model="ruleForm.user_name" type="text" >
				</el-input>
			</el-form-item>
			<el-form-item label="身份证号码" prop="id_card" class="withdrawal">
				<el-input placeholder="请输入身份证号码"  v-model="ruleForm.id_card" type="text" >
				</el-input>
			</el-form-item>
			<el-form-item class="mb0" label="验证码" prop="sms_code">
				<div class="weui-cell pd0">
					<div class="weui-cell__bd"><el-input placeholder="请输入手机验证码"  v-model="ruleForm.sms_code" type="tel" maxlength="6" class="sms-form-item"></el-input></div>
					<div class="weui-cell__ft ml10" style="width: 20%"><el-button class="block pl0 pr0" style="width: 100%" :disabled="disabled" @click="sendCode(ruleForm.phone)">{{codeText}}</el-button></div>
				</div>
			</el-form-item>
			<el-form-item>
				<p class="noticeP">验证码将发送至手机号码为{{ruleForm.phone | phoneFilter}}，请输入正确验证码</p>
				<p style="color:red; line-height: 25px;">注意：</p>
				<p style="color:red; line-height: 25px;">1：工作日24小时内到账，节假日顺延, 资金会提现到首次扫码绑定的微信零钱里。   </p>
				<p style="color:red; line-height: 25px;">2：若提现中遇到了任何问题，可咨询商务或拨打客服电话400-800-0907。</p>
				<p style="color:red; line-height: 25px;">3：请确定商家绑定的微信已实名，提现不支持给非实名用户打款。</p>
				<p style="color:red; line-height: 25px;">4：单笔单日限额5千元，可分批提现，次日到账。</p>
				<!-- <a href="https://kf.qq.com/faq/140225MveaUz1501077rEfqI.html" style="color:red;font-weight: bold; font-size:15px" target="_blank">备注：具体结算周期和结算费率</a> -->
			</el-form-item>
			<el-form-item class="accountWdrawal_btn-mar">
				<el-button type="primary" @click="submitForm('ruleForm')" :disabled="withdrawalAmountDisabled">提交</el-button>
				<el-button @click="resetForm('ruleForm')">重置</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
import api from "@/api.js";
export default {
	name: 'accountWdrawal',
	data() {
		var validateWithdrawalAmount = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入提现金额'));
			} else {
				value = parseFloat(value)
				if (value > parseFloat(this.ruleForm.account)) {
					callback(new Error('该金额已超过账户余额'));
				} else {
					if (value < 1.5 || value >5000) {
						callback(new Error('单次提现金额在1.5-5000之间'));
					} else {
						callback();
					}
				}
			}
		};	
		return {
			withdrawalAmountDisabled: false,
			ruleForm: {
				account: 0,
				phone: '',
				withdrawalMethod: 1,
				withdrawalAmount: 0,
				sms_code: "",
				user_name: '',
				id_card: ''
			},
			codeText: "获取验证码",
			disabled: false,	
			count: null,
			second: 60, 
			rules: {
				withdrawalMethod: [
					{required: true, message: '请选择提现方式', trigger: 'change'}
				],
				withdrawalAmount: [
					{required: true, validator: validateWithdrawalAmount, trigger: 'blur'}
				],
				user_name: [
					{required: true,message: '请输入真实姓名！',  trigger: 'blur'}
				],
				id_card: [
					{required: true, pattern: /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/, message: '请输入正确的身份证号', trigger: 'blur'}
				]
			},
			result: {}
		}
	},
	filters: {
		phoneFilter(val) {
			let reg = /^(.{3}).*(.{4})$/;
			return val.replace(reg,'$1****$2');
		} 			
	},
	mounted() {
		// 获取用户余额
		// this.axios.post(api.getUserInfo, {}).then(response => {
		// 	if (response.data.code === 0) {
		// 		// console.log('获取用户余额',response.data.result)
		// 		this.result = response.data.result;
		// 		this.ruleForm.account = response.data.result.balance
		// 		this.ruleForm.phone = response.data.result.phone
		// 		if(this.ruleForm.account == 0){
		// 		this.withdrawalAmountDisabled = true
		// 		}else{
		// 			this.withdrawalAmountDisabled = false
		// 		}
		// 	} 
		// }).catch(() => {});       
	},
	methods: {
		// 获取验证码
		sendCode(value) {
			let self = this;
			self.disabled = true;
			self.axios
				.post(api.sendSmsCode, {
					tel: value,
					type: 3
				})
				.then(response => {
					if (response.data.code == 0) {
						this.$message.success(response.data.msg);
						self.count = setInterval(() => {	
							self.second--;
							self.codeText = self.second + 's';
							if (self.second==0) {
								clearInterval(self.count);
								self.codeText = '获取验证码';
								self.disabled = false;
								self.second = 60;
							};
						}, 1000);
					} else {
						self.disabled = false;
					}
				}).catch(() => {});
		},
		// 提交表单
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				let method = this.ruleForm.withdrawalMethod;
				let withdrawalAmount = this.ruleForm.withdrawalAmount;
				let sms_code = this.ruleForm.sms_code;
				let tel = this.ruleForm.phone;
				let user_name = this.ruleForm.user_name;
				let id_card = this.ruleForm.id_card;
				if (valid) {
					this.withdrawalAmountDisabled = true; // 将提交按钮设为disabled
					// 点击确认按钮后提交提现操作
					this.axios.post(api.withdrawMoney, {
						type: method,
						amount: withdrawalAmount,
						sms_code: sms_code,
						tel: tel,
						user_name: user_name,
						id_card: id_card
					}).then(res => {
						if (res.data.code == 0) {
							this.ruleForm.withdrawalMethod = 1;
							this.ruleForm.withdrawalAmount = 0;
							this.ruleForm.sms_code = '';
							this.ruleForm.codeText = '获取验证码';
							this.$message({
								message: '已成功提交!'
							});
							this.withdrawalAmountDisabled = false;
							location.reload();
						}	else {
							this.withdrawalAmountDisabled = false;
						}
					}).catch(res => { 
						this.withdrawalAmountDisabled = false;
						this.msg = res.msg;
					});	
				} else {
					return false;
				}
			})
		},
		// 重置
		resetForm(formName) {
			// this.$refs[formName].resetFields();
			this.ruleForm.withdrawalAmount = 0;
			this.ruleForm.withdrawalMethod = 1;
			this.ruleForm.sms_code = '';
			this.ruleForm.codeText = '获取验证码';
			this.ruleForm.user_name = '';
			this.ruleForm.id_card = '';
		},
		checkMoney(num) {
			var str = num;
			var len1 = str.substr(0, 1);
			var len2 = str.substr(1, 1);
			// 如果第一位是0，第二位不是点，就用数字把点替换掉
			if (str.length > 1 && len1 == 0 && len2 != '.') {
				str = str.substr(1, 1);
			}
			// 第一位不能是.
			if (len1 == '.') {
				str = '';
			}
			// 限制只能输入一个小数点
			if (str.indexOf('.') != -1) {
				var str_ = str.substr(str.indexOf('.') + 1);
				if (str_.indexOf('.') != -1) {
					str = str.substr(0, str.indexOf('.') + str_.indexOf('.') + 1);
				}
			}
			// 正则替换  
			str = str.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');  // 小数点后只能输两位
			return str;
		}
	}
}
</script>
